// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import TranslationOfTextContentResourceViewModel from '../../../../viewModel/resource/TranslationOfTextContentResourceViewModel';
import TranslationOfTextContentResourceDTO from '../../dto/resource/TranslationOfTextContentResourceDTO';

export default abstract class TranslationOfTextContentResourceModel extends BaseModel<TranslationOfTextContentResourceDTO> {
  /**
  */
  get translatedContent() { return this.dto.translatedContent; }
  set translatedContent(value) { this.dto.translatedContent = value; }
  /**
  */
  get language() { return this.dto.language; }
  set language(value) { this.dto.language = value; }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    this.dto.translatedContent = qs.translatedcontent;
    this.dto.language = qs.language;
  }
}
